/**
 * Extract segment name as a plain string.
 */
export function segmentTransform(segment) {
    return segment ? segment.segmentName : undefined;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@splitsoftware/splitio-commons/esm/evaluator/matchersTransform/segment.js
// module id = 3765
// module chunks = 25